import { useState } from "react";
import type { FaqItem } from "@/mocks/characters";

export default function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number>(0);
  return (
    <div className="space-y-3">
      {items.map((item, i) => {
        const open = openIndex === i;
        return (
          <div
            key={item.q}
            className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
          >
            <button
              type="button"
              onClick={() => setOpenIndex(open ? -1 : i)}
              className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left md:px-5"
              aria-expanded={open}
            >
              <span className="flex items-center gap-3 text-sm font-medium text-foreground-950 md:text-base">
                <span className="grid h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-xs font-bold text-secondary-700">
                  {String(i + 1).padStart(2, "0")}
                </span>
                {item.q}
              </span>
              <i
                className={`shrink-0 text-lg text-foreground-500 transition-transform duration-300 ${
                  open ? "ri-subtract-line" : "ri-add-line"
                }`}
              ></i>
            </button>
            <div
              className={`grid transition-all duration-300 ${
                open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
              }`}
            >
              <div className="overflow-hidden">
                <p className="px-4 pb-4 pl-14 text-sm leading-7 text-foreground-700 md:px-5 md:pb-5 md:pl-14">
                  {item.a}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}